<template>
    <Loading v-if="loading"/>

    <ResourceListHeader :addLabel="addLabel"
                        :addRoute="addRoute"
                        :title="title"
    >
        <template #actions>
            <slot name="headerActions" />
        </template>
    </ResourceListHeader>

    <template v-for="resource in collection">
        <component :is="renderAs" :resource="resource"/>
    </template>

    <Paginator :paginator="paginator"
               :perPage="perPage"
               :perPageOptions="perPageOptions"
               @previous="handlePagePrevious"
               @next="handlePageNext"
               @update:perPage="handlePerPageChange"
    />
</template>

<script>
import {
  mapActions,
} from 'vuex';

import Paginator from '@/components/Paginator.vue';
import ResourceListHeader from '@/components/ResourceListHeader.vue';
import ResourceListItem from '@/components/ResourceListItem.vue';

/**
 * Load the data based on the url
 * Use the query to manage paginator
 */


export default {
  name: 'ResourceList',
  components: {
    Paginator,
    ResourceListHeader,
    ResourceListItem,
  },
  computed: {
    collection() {
      return this.resource.vuexModuleKey ? this.$store.getters[`${this.resource.vuexModuleKey}/collection`](this.ids) : [];
    },
    indexAction() {
      return this.resource.vuexModuleKey ? `${this.resource.vuexModuleKey}/index` : null;
    },
    perPage() {
      return this.parsePerPage(this.$route.query.perPage);
    },
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      ids: [],
      loading: false,
      paginator: null,
      header: {},
      perPageOptions: [10, 25, 50, 100],
    };
  },
  methods: {
    ...mapActions({}),
    loadData(page = null, inBackground = false) {

      if (!this.indexAction) {
        console.error('No indexAction');
        return false;
      }

      let params = {
        page: page || this.$route.query.page || 1,
        perPage: this.perPage,
        ...this.params,
        ...this.query,
      };

      this.loading = !inBackground;
      return this.$store.dispatch(this.indexAction, {
        params,
      }).then(({ids, paginator}) => {
        this.ids = ids;
        this.paginator = paginator;
      }).finally(() => {
        this.loading = false;
      });
    },
    handlePageNext() {
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          page: this.paginator.currentPage + 1,
          perPage: this.perPage,
        }
      });
    },
    handlePagePrevious() {
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          page: this.paginator.currentPage - 1,
          perPage: this.perPage,
        }
      });
    },
    handlePerPageChange(perPage) {
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          page: 1,
          perPage: this.parsePerPage(perPage),
        }
      });
    },
    parsePerPage(value) {
      const perPage = Number(value);

      if (this.perPageOptions.includes(perPage)) {
        return perPage;
      }

      return this.perPageOptions[0];
    },
  },
  props: {
    addLabel: {
      default: null,
      required: false,
      type: String,
    },
    addRoute: {
      required: false,
    },
    params: {
      default: () => {
      },
      required: false,
    },
    query: {
      default: () => {
      },
      required: false,
    },
    renderAs: {
      default: () => ResourceListItem,
      required: false,
    },
    resource: {
      required: true,
    },
    title: {
      default: () => '',
      type: String,
    }
  },
  watch: {
    ['$route']: {
      deep: true,
      handler() {
        this.loadData();
      },
    }
  }
}
</script>

<style scoped lang="scss">

</style>
